// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3YVxT","item":"PaymentsMobile_item__3m5hQ","label":"PaymentsMobile_label__3EKBl","amount":"PaymentsMobile_amount__ss49v"};